
import axios from 'Axios'
const getSubjectId = {
	state: {
		SubjectList:'',
		AllSubjectList: ''
	},
	mutations: {
		GET_ALL_SUBJECT: (state,view)=>{
			state.AllSubjectList = view;
		},
		GET_SUBJECT: (state , view)=>{
			state.SubjectList = view;
		},
		GET_SUBJECT_CHANGE: (state , view)=>{},
		CLEAR_SUBJEXT_STATE:(state)=>{
			state.AllSubjectList = '';
			state.SubjectList = '';
		}
	},
	actions: {
		getAllSubject({commit},params) {
			axios.post('subject/getAllSujectByContent',{}).then(res=>{
				if(res.data.code=='1') {
					if(res.data.data.length){
						res.data.data.forEach(i=>{
							i.labels = i.code+'\xa0\xa0'+i.name;
						})
					}
					commit('GET_ALL_SUBJECT' , res.data.data);
				}
				return res.data.data
			})
			
		},
		getSubject({commit},params) {
			try{
				axios.post('subject/getSujectByContent',{}).then(res=>{
					if(res.data.code=='1') {
						if(res.data.data.length){
							res.data.data.forEach(i=>{
								i.labels = i.code+'\xa0\xa0'+i.name;
							})
						}
						commit('GET_SUBJECT' , res.data.data);
					}
					return res.data.data
				})

			}catch(e){
				console.log(e)
			}
			
		},
		
	}
}

export default getSubjectId



// WEBPACK FOOTER //
// ./src/store/modules/getSubject.js